import styled from "styled-components"


export const ContactDetailsWrap = styled.div`
   overflow-wrap: break-word;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/PlaceDetails/styled.js